import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useCreateParticipant = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (body: any) => {
      return axios.put(`/participant`, body)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['participant'])
      }
    }
  )
}
